import React, {useState} from 'react';
import {PageHeader} from "../../../../components/PageHeader";
import PurchaseListListType from "./subPages/PurchaseListListType";
import {useDispatch} from "react-redux";
import {setKeys} from "../../../../redux/slice/searchSlice";
import useRequestData from "../../../../hooks/useRequestData";
import {toKSTISOString, toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import {getPurchaseList} from "../../../../api/asset/PurchaseService";

function Purchase() {

    const [listType, setListType] = useState(true)
    const [checked,setChecked] = useState([]);
    const dp = useDispatch();
    dp(setKeys({keys:"Purchase"}))
    // const keys="license";


    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const { newData, pageInfo, dataHook } =
        useRequestData(getPurchaseList, initDate, 'purchase');

    return (
       <>
           <div className="common-container">
               <PageHeader header={"구매관리"} indicator={"자산관리 > 자산재무관리 > 구매관리"}/>
                   <PurchaseListListType
                       data={newData}
                       date={initDate}
                       pageInfo={pageInfo}
                       dataHook={dataHook}
                       checked={{checked: checked, setChecked: setChecked}} />
           </div>
       </>
    );
}

export default Purchase;